import React from 'react';

import benefits from '../../../assets/images/benefits.jpg';
import check from '../../../assets/images/benefits-check.svg';

const Benefits = () => {
  return (
    <section className="utility-collection">
      <div className="px-5 md:px-10">
        <div className="benefits-header text-center py-10">
          <h1 className="lt-white font-bold text-4xl md:text-5xl mb-5">
            The MetaFans NFT Collections
          </h1>
          <h2 className="text-grey width-[75%] mx-auto font-medium text-lg md:text-xl text-center tracking-tight">
            We love art, blockchain, and sports but there’s nothing like
            community! MetaFans NFT collectors are part of an active, growing
            community where you can share your love of sports!
          </h2>
        </div>
        <div className="benefits-info flex flex-col-reverse lg:flex-row items-start justify-center">
          <div className="w-full lg:w-1/2">
            <h1 className="lt-white font-bold leading-tight text-3xl md:text-4xl mb-5">
              No other sport-focused NFT has the utility MetaFans has!
            </h1>
            <div className="benefits-list lt-white">
              <div className="flex align-center justify-start single-benefit gap-3">
                <div>
                  <img
                    className="w-[1.5rem] md:w-[2rem]"
                    src={check}
                    alt="metafans benefits"
                  />
                </div>
                <div>
                  <p className="font-medium text-lg tracking-tight text-base md:text-lg">
                    The chance to win free tickets to IRL events!
                  </p>
                </div>
              </div>
              <div className="flex align-center justify-start single-benefit gap-3">
                <div>
                  <img
                    className="w-[1.5rem] md:w-[2rem]"
                    src={check}
                    alt="metafans benefits"
                  />
                </div>
                <div>
                  <p className="font-medium text-lg tracking-tight text-base md:text-lg">
                    Sports Pools and Sports Pick'ems.
                  </p>
                </div>
              </div>
              <div className="flex align-center justify-start single-benefit gap-3">
                <div>
                  <img
                    className="w-[1.5rem] md:w-[2rem]"
                    src={check}
                    alt="metafans benefits"
                  />
                </div>
                <div>
                  <p className="font-medium text-lg tracking-tight text-base md:text-lg">
                    Exclusive access to the <a className="underline" href="https://ticket.metafans.com/" target="_blank">MetaFans ticket site</a>, for the best
                    aftermarket ticket prices.
                  </p>
                </div>
              </div>
              <div className="flex align-center justify-start single-benefit gap-3">
                <div>
                  <img
                    className="w-[1.5rem] md:w-[2rem]"
                    src={check}
                    alt="metafans benefits"
                  />
                </div>
                <div>
                  <p className="font-medium text-lg tracking-tight text-base md:text-lg">
                    Additional perks and utility benefits on our <a className="underline" href="https://www.gameblazers.com/" target="_blank">GameBlazers platform</a>!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 mt-5 lg:mt-0">
            <img
              className="mx-auto"
              src={benefits}
              alt="Metafans Benefits"
            ></img>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
